import { render, staticRenderFns } from "./BusinessScope.vue?vue&type=template&id=1fc10640&"
import script from "./BusinessScope.vue?vue&type=script&lang=js&"
export * from "./BusinessScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports